/**
 * Signing Account Status enum - defines the lifecycle states of signing accounts.
 *
 * This enum is shared across domains to maintain consistency in status management.
 */
export var SigningAccountStatus;
(function (SigningAccountStatus) {
    /** Account is ready for use with all required information */
    SigningAccountStatus["ACTIVE"] = "active";
    /** Account is temporarily disabled but can be reactivated */
    SigningAccountStatus["INACTIVE"] = "inactive";
    /** Account is permanently disabled and cannot be used */
    SigningAccountStatus["REVOKED"] = "revoked";
})(SigningAccountStatus || (SigningAccountStatus = {}));
//# sourceMappingURL=signing-account-status.enum.js.map